import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import DayJsAdapter from '@date-io/dayjs';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    date: {
        adapter: DayJsAdapter,
    },
});

export default vuetify;

